(()=>{
const arrange=()=>{
const bundle=document.getElementById('sym-bundle');
const details=document.querySelector('.productView-details');
if(!bundle||!details||bundle.dataset.symV5Placed==='1')return;
const title=details.querySelector('.productView-title');
const price=details.querySelector('.productView-price');
const titleHolder=title?.closest('.productView-moreItem');
const priceHolder=price?.closest('.productView-moreItem');
if(titleHolder&&priceHolder&&titleHolder!==priceHolder)titleHolder.insertAdjacentElement('afterend',priceHolder);
if(priceHolder)priceHolder.insertAdjacentElement('afterend',bundle);
else if(titleHolder)titleHolder.insertAdjacentElement('afterend',bundle);
else details.prepend(bundle);
const variant=details.querySelector('.productView-moreItem-product-variant');
const buttons=details.querySelector('.productView-buttons')?.closest('.productView-moreItem');
const quantity=details.querySelector('.productView-quantity')?.closest('.productView-moreItem');
for(const el of [variant,buttons,quantity]){if(el)el.classList.add('sym-v5-original-control')}
bundle.dataset.symV5Placed='1';
document.body.classList.add('sym-v5-has-bundle');
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arrange,{once:true});
else arrange();
})();
